module.exports = "https://activity.hdslb.com/blackboard/activity87093/img/bonus-reward.4cb8ae87.png";